module.exports = __webpack_public_path__ + "static/img/v77Bg-p.83b56e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v77Bg-p.png
// module id = EH1X
// module chunks = 1